import React, { Component, Fragment } from 'react';
import './AbstractHomePage.css';

import NavbarHeader from 'pages/header/NavbarHeader';

export default class AbstractHomePage extends Component {
  render() {
    return (
      <Fragment>
        <div>
          <NavbarHeader />
        </div>
      </Fragment>
    );
  }
}
